import { createAsyncThunk } from '@reduxjs/toolkit';
import TeamMeetingsAPI from './teamMeetingsApi';

export const fetchMeetingsThunk = createAsyncThunk(
  'teamMeetings/fetchMeetings',
  async (_params, { rejectWithValue }) => {
    try {
      return await TeamMeetingsAPI.fetchMeetings();
    } catch (err) {
      return rejectWithValue(err?.response?.data?.detail || err.message || 'Failed to load meetings');
    }
  }
);

export const fetchMeetingThunk = createAsyncThunk(
  'teamMeetings/fetchMeeting',
  async (meetingId, { rejectWithValue }) => {
    try {
      return await TeamMeetingsAPI.fetchMeeting(meetingId);
    } catch (err) {
      return rejectWithValue(err?.response?.data?.detail || err.message || 'Failed to load meeting');
    }
  }
);

export const createMeetingThunk = createAsyncThunk(
  'teamMeetings/createMeeting',
  async (meetingData, { rejectWithValue }) => {
    try {
      return await TeamMeetingsAPI.createMeeting(meetingData);
    } catch (err) {
      return rejectWithValue(err?.response?.data?.detail || err.message || 'Failed to create meeting');
    }
  }
);

export const updateMeetingThunk = createAsyncThunk(
  'teamMeetings/updateMeeting',
  async ({ meetingId, updates }, { rejectWithValue }) => {
    try {
      return await TeamMeetingsAPI.updateMeeting(meetingId, updates);
    } catch (err) {
      return rejectWithValue(err?.response?.data?.detail || err.message || 'Failed to update meeting');
    }
  }
);

export const deleteMeetingThunk = createAsyncThunk(
  'teamMeetings/deleteMeeting',
  async (meetingId, { rejectWithValue }) => {
    try {
      return await TeamMeetingsAPI.deleteMeeting(meetingId);
    } catch (err) {
      return rejectWithValue(err?.response?.data?.detail || err.message || 'Failed to delete meeting');
    }
  }
);
